









































	// @ts-ignore
    import _ from './ProcedureDomainMoveInAccount.ts'; export default _;
